import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-24 relative overflow-hidden section-premium-dark texture-grain">
      {/* Soft Radial Glow Effects */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-gold/10 rounded-full blur-[150px] animate-pulse-soft" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[180px] animate-pulse-soft" style={{ animationDelay: '1.5s' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-gold/5 rounded-full blur-[100px]" />
      
      {/* Floating Accent Shapes */}
      <div className="absolute top-20 right-32 w-16 h-16 border border-gold/10 rounded-full animate-float opacity-30" />
      <div className="absolute bottom-32 left-20 w-10 h-10 border border-primary/20 rounded-full animate-float opacity-20" style={{ animationDelay: '2s' }} />

      {/* Subtle Dot Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 text-gold font-semibold text-sm uppercase tracking-wider mb-4">
            <span className="w-8 h-px bg-gold/50" />
            GET STARTED
            <span className="w-8 h-px bg-gold/50" />
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-white leading-tight mb-6">
            Ready to Fuel Your
            <span className="block text-gold relative inline-block">
              Performance?
              {/* Subtle glow behind text */}
              <span className="absolute inset-0 blur-2xl bg-gold/20 -z-10" />
            </span>
          </h2>
          <p className="text-lg text-white/60 leading-relaxed mb-10 max-w-xl mx-auto">
            Join thousands of athletes and fitness enthusiasts who trust NutraFuel for their supplement needs.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10">
            <Button size="xl" className="btn-whatsapp bg-green-500 hover:bg-green-600 text-white border-0 shadow-lg shadow-green-500/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-green-500/40 active:scale-95" asChild>
              <a href="https://wa.me/9779824042067" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current mr-2">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Order on WhatsApp
              </a>
            </Button>
            <Button size="xl" className="bg-white/5 hover:bg-white/10 text-white border border-white/20 backdrop-blur-sm transition-all hover:-translate-y-0.5" asChild>
              <a href="tel:+9779824042067">
                <Phone className="w-5 h-5 mr-2" strokeWidth={1.5} />
                Call Us Now
              </a>
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-4 text-sm text-white/50">
            {['100% Authentic', 'Expert Guidance', 'Fast Delivery'].map((item) => (
              <span key={item} className="flex items-center gap-2">
                <svg className="w-4 h-4 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
